module.exports = "<app-header></app-header>\n <div class=\"container-fluid py-5 allcenter\">\n     <div class=\"row w-100\">\n         <div class=\"col-md-12 text-center\">\n            <h1 class=\"text-uppercase m-0\">Forbidden</h1>\n            <h3 class=\"text-grey mt-2\">YOU ARE NOT ALLOWED TO BE HERE</h3>\n            <a uiSref=\"dashboard\" class=\"btn btn-warning btn-lg mt-2\">DASHBOARD</a>\n         </div>\n     </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/forbidden/forbidden.component.html
// module id = ../../../../../src/app/components/forbidden/forbidden.component.html
// module chunks = main